import styled from "styled-components";

export const Container = styled.div`;
  border-radius: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 220px;
  height: 85px;
  white-space: nowrap;
  padding: 0 40px 0 20px;
`;

export const TextContainer = styled.div`
  flex-direction: column;
  width: 70%;
  align-items: self-end;
  margin-left: 20px;
`;

export const Label = styled.div`
  font-size: 18px;
  font-weight: bold;
  line-height: 25px;
  color: #ffffff;
`;

export const NumberLabel = styled.div`
  font-size: 21px;
  font-weight: 500;
  line-height: 25px;
  color: #ffffff;
  margin-top: 4px;
`;

export const IconWrapper = styled.div`
  background: rgba(255, 255, 255, 0.2) 0% 0% no-repeat padding-box;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 59px;
  width: 59px !important;
  overflow: hidden;
`;

export const RowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
